"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
function ArvatoAddLocationPlaceholderEvent(resources) {
    return new Types_1.VeriLiteInformationEvent(React.createElement("div", null,
        React.createElement("span", null, "Self management of locations is temporarily unavailable. To add or edit a location, please contact "),
        React.createElement("a", { className: "email-link", href: "mailto:" + resources.VeriLiteSupportEmail }, resources.VeriLiteSupportEmail),
        React.createElement("span", null, ".")), resources.CreateLocation_Heading, [
        new Types_1.VeriLiteEventAction(resources.Close, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]);
}
exports.ArvatoAddLocationPlaceholderEvent = ArvatoAddLocationPlaceholderEvent;
//# sourceMappingURL=ArvatoAddLocationPlaceholderEvent.js.map